import CarouselMenu from '../Components/Carousel/CarouselMenu';
import '../assets/styles/menu.css';
import { Carousel } from 'react-bootstrap';
import menuData from '../Pages/menuData'; 
import Juice from "../assets/Images/02.png";
import Pastamenu from "../assets/Images/pasta.jpg";
import SaladAndSoup from "../assets/Images/salad2.jpg";
import Rice from "../assets/Images/01.png";
import Appetizer from "../assets/Images/wings.jpg";
import Kottu from '../assets/Images/Starter2.png';
import Bites from '../assets/Images/sandwich.jpg'
const Menu = () => {
  const { juiceMenuItems = [], appetizerMenuItems = [], bitesMenuItems = [], pastaMenuItems = [], noodlesMenuItems = [], kottuMenuItems = [], riceMenuItems = [] } = menuData;

  return (
    <>
      {/* Inner Banner */}
      <div className="inner-banner d-flex flex-column text-center py-5">
        <div className="innerbanner-text">
          <h3 className="text-uppercase text-white my-2">Our Main Menu</h3>
          <h1 className="display-4 fw-bold innerbanner-title my-3">A Journey Through Taste</h1>
          <p className="lead">
            A Fusion of Dining and Sports Entertainment at Green View Peak: <br />
            Enjoy delicious meals while catching the latest sports action
          </p>
        </div>
        <CarouselMenu />
      </div>

      {/* Menu Section */}
      <div className="menu-book container text-center py-3">
        <Carousel indicators={true} controls={true} interval={null}>
          {/* Fresh Juice Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
            <h2 className="text-white mb-4">
              <span className="Juice-style">Fresh Juice</span>
            </h2>
              <img src={Juice} className="card-img-top mb-4" alt="Juice" />
              <div className="row my-5">
                {juiceMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Carousel.Item>

          {/* Appetizer Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
              <h2 className="text-white mb-4">Appetizer</h2>
              <img src={Appetizer} className="card-img-top mb-4" alt="Main Course" />
              <div className="row my-5">
                {appetizerMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Carousel.Item>

          {/* Bites Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
              <h2 className="text-white mb-4">Bites</h2>
              <img src={Bites} className="card-img-top mb-4" alt="Dessert" />
              <div className="row my-5">
                {bitesMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Carousel.Item>

          {/* Pasta Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
              <h2 className="text-white mb-4">Pasta</h2>
              <img src={Pastamenu} className="card-img-top mb-4" alt="Dessert" />
              <div className="row my-5">
                {pastaMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
                <p>Add full Pasta: <span className="text-warning">Rs.200</span></p>
              </div>
            </div>
          </Carousel.Item>

          {/* Fried Noodles Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
              <h2 className="text-white mb-4">Fried Noodles</h2>
              <img src={SaladAndSoup} className="card-img-top mb-4" alt="Dessert" />
              <div className="row my-5">
                {noodlesMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
                <p>Add full Noodle: <span className="text-warning">Rs.200</span></p>
              </div>
            </div>
          </Carousel.Item>

          {/* Fried Kottu Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
              <h2 className="text-white mb-4">Fried Kottu</h2>
              <img src={Kottu} className="card-img-top mb-4" alt="Dessert" />
              <div className="row my-5">
                {kottuMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
                <p>Add full Kottu : <span className="text-warning">Rs.200</span></p>
              </div>
            </div>
          </Carousel.Item>

          {/* Fried Rice Page */}
          <Carousel.Item>
            <div className="menu-section container text-center py-5 my-5">
              <h2 className="text-white mb-4">Fried Rice</h2>
              <img src={Rice} className="card-img-top mb-4" alt="Dessert" />
              <div className="row my-5">
                {riceMenuItems.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card text-white">
                      <div className="card-body text-start">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.description}</p>
                        <h5 className="text-warning">{item.price}</h5>
                      </div>
                    </div>
                  </div>
                ))}
                <p>Add full Rice : <span className="text-warning">Rs.200</span></p>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </>
  );
};

export default Menu;
